import React, { useContext, useEffect, useRef, useState } from "react";
import * as Scrivito from "scrivito";
import { useLocalsStore } from "stores/localsStore";
import { lastSelectedUserLangLSKey } from "variables/localStorageItemsNames";
import { useAuthStore } from "stores/authStore";

const AppBaseContext = React.createContext({});

const isProd = process.env.TROX_ENVIRONMENT === "production";

export const AppBaseProvider = Scrivito.connect(({ children }) => {
  const loadLocals = useLocalsStore((state) => state.fetch);
  const page = Scrivito.currentPage();
  const hasFetchedUserData = useRef(false);
  const authActions = useAuthStore.use.actions();

  const [lang, setLang] = useState(
    () =>
      localStorage.getItem(lastSelectedUserLangLSKey) ||
      Scrivito.currentPage()?.get("categoryLanguages")?.[0] ||
      "de",
  );

  useEffect(() => {
    if (hasFetchedUserData.current || !page) return;
    const pageClass = page?.objClass();
    const isLoginPage = pageClass === "LoginPage";
    if (pageClass && !isLoginPage) {
      authActions.fetchUserData();
      hasFetchedUserData.current = true;
    }
  }, [authActions, page]);

  useEffect(() => {
    loadLocals(lang);
  }, [lang, loadLocals]);

  return (
    <AppBaseContext.Provider
      value={{
        lang,
        isSameProj:
          Scrivito.currentPage()?.path()?.startsWith("/same") ||
          process?.env?.REACT_APP_IS_SAME === "true",
        isProd,
        setLang,
      }}
    >
      {children}
    </AppBaseContext.Provider>
  );
});

export const useAppBaseContext = () => useContext(AppBaseContext);
